






















































import {
  Component,
  Prop,
  Vue,
  Mixins,
  Watch,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { specialChannel } from "@root/lib/mixins";
import gtMedia from "@/components/pages/ProductCreate/media.vue";
import channelCategory from "@/components/pages/ProductCreate/channelCategory.vue";
import channelAttributeBLock from "@/components/pages/ProductCreate/channelComponents/channelAttributeBLock.vue";
import channelDescriptionBlock from "@/components/pages/ProductCreate/channelComponents/channelDescriptionBlock.vue";
const productCreate = namespace("productCreate");
@Component({
  components: {
    gtMedia,
    channelCategory,
    channelAttributeBLock,
    channelDescriptionBlock
  }
})
export default class channelSpuTab extends Mixins(specialChannel) {
  @productCreate.Action queryConnAttrList;
  // @productCreate.Action getConnExtendParams;
  @productCreate.Action getProductChannel;
  @productCreate.Getter propertiesData;
  @productCreate.Mutation setChannelProduct;
  @InjectReactive("curChannel") curChannel;
  @InjectReactive("curCategory") curCategory;
  @InjectReactive("curBrandId") curBrandId;
  @Prop({ default: false }) isEdit;
  @Prop({ default: "" }) info;
  @Prop({ default: false }) readonly;
  private vaildates = [];
  baseConnAttrList = [];
  connAttrList = [];
  editorList = [];
  spuData: any = {};
  imageList = [];
  categoryAttrObj = {};
  channelProductCode = "";
  loading = false;
  noCategory: any = "";
  get isSpuSaved() {
    return !this.curChannel.isEdit;
  }
  get emptyAttr() {
    return (
      this.baseConnAttrList.length === 0 &&
      this.connAttrList.length === 0 &&
      this.editorList.length === 0 &&
      this.imageList.length === 0
    );
  }
  @Watch("info", { immediate: true })
  watchInfo(val) {
    if (val) {
      this.channelProductCode = val.channelProductCode;
    }
    // if (val) {
    //   let res = JSON.parse(val);
    // }
  }
  async created() {
    if (!this.curCategory || this.curCategory.length === 0) {
      if (!this.isSpuSaved) {
        this.noCategory = this.$t("20200917.Product.noCategoty");
      }
      return;
    }
    this.noCategory = "";
    this.loading = true;
    await this.getChannelProduct();
    let param: any = {
      channelCode: this.curChannel.channelCode,
      shopCode: this.curChannel.value,
      categoryId: this.curCategory[this.curCategory.length - 1]
    };

    if (this.curBrandId && this.isTmall(this.curChannel.channelCode)) {
      param.brandId = this.curBrandId;
    }
    let productAttrList = await this.queryConnAttrList({
      input: {
        ...param,
        attrType: 1
      }
    });
    let { baseConnAttrList = [], connAttrList = [] } = productAttrList;
    // let { baseConnAttrList = [], connAttrList = [] } = this.productAttrList;
    this.imageList = [];
    let obj = baseConnAttrList.filter(_ => _.attrCode === "categoryId");
    this.categoryAttrObj = obj ? obj[0] : {};
    this.$emit("getCategoryAttr", this.categoryAttrObj);
    baseConnAttrList.forEach(_ => {
      // 富文本编辑器
      if (_.attrValueType === 4 && _.attrCode === "description") {
        this.editorList.push(_);
      }
      // 图片
      // else if (_.attrCode === "images") {
      //   this.imageList.push(_);
      // }
      // 不包含分类的其他属性
      else if (!["categoryPath", "categoryId"].includes(_.attrCode)) {
        this.baseConnAttrList.push(_);
      }
    });
    this.connAttrList = connAttrList;
    this.loading = false;
  }
  async getChannelProduct() {
    let res = await this.getProductChannel({
      productCode: this.propertiesData.productCode,
      shopCode: this.curChannel.value
    });

    if (res && res.extendParams) {
      this.spuData = JSON.parse(res.extendParams);
    }
  }
  vaildateRegister(fn) {
    this.vaildates.push(fn);
  }
  vaildateRemove(fn) {
    let index = this.vaildates.findIndex(item => item === fn);

    if (index > -1) {
      this.vaildates.splice(index, 1);
    }
  }
  submit() {
    console.log(this.vaildates.length, "this.vaildates", this.vaildates);

    return Promise.all(this.vaildates.map(vaildate => vaildate()));
  }
  switchCategory(data) {
    this.$emit("switchCategory", data);
  }
  switchBrand(data) {
    this.$emit("switchCategory", data);
  }
}
